{
  "invalidSelection": "Выбранные {selectedCount, plural, one {дата} other {даты}} недоступны."
}
